<template>
  <patient-profile>
    <div class="invoice-list-invoices__section">
      <patient-paid-stats
        v-if="isShowPatientPayments"
        v-bind:advance="patientPayments.advance"
        v-bind:debt="patientPayments.debt"
        v-bind:is-await-force-recharge="isAwaitForceRecharge"
        v-bind:is-await-recharge="isAwaitCommandExecuted"
        v-bind:paid="patientPayments.paid"
        v-bind:can-force-recharge="canForceRecharge"
        v-on:advance-details-open="onAdvanceDetailsOpen"
        v-on:open-recharge-form="onOpenAdvanceRechargeForm"
        v-on:withdrawal-open="onOpenAdvanceWithdrawalForm"
        v-on:force-recharge="onForceAdvanceRecharge"
        v-on:print-act="onPrintAct"
      />
      <div class="invoice-list__filters">
        <input
          hidden
          type="radio"
          v-bind:id="$options.filterByAllStatus"
          v-bind:value="$options.filterByAllStatus"
          v-model="filterByStatus"
        />
        <label
          class="invoice-list__filters__item"
          v-bind:for="$options.filterByAllStatus"
        >
          Все
        </label>
        <input
          v-bind:id="$options.filterByPayedStatus"
          hidden
          type="radio"
          v-bind:value="$options.filterByPayedStatus"
          v-model="filterByStatus"
        />
        <label
          class="invoice-list__filters__item invoice-list__icon payed"
          v-bind:for="$options.filterByPayedStatus"
        >
          Оплачено
        </label>
        <input
          hidden
          type="radio"
          v-bind:id="$options.filterByPartiallyPayedStatus"
          v-bind:value="$options.filterByPartiallyPayedStatus"
          v-model="filterByStatus"
        />
        <label
          class="invoice-list__filters__item invoice-list__icon partially_payed"
          v-bind:for="$options.filterByPartiallyPayedStatus"
        >
          Частично оплачено
        </label>
        <input
          hidden
          type="radio"
          v-bind:id="$options.filterByWaitStatus"
          v-bind:value="$options.filterByWaitStatus"
          v-model="filterByStatus"
        />
        <label
          class="invoice-list__filters__item invoice-list__icon wait"
          v-bind:for="$options.filterByWaitStatus"
        >
          Ожидает оплаты
        </label>
        <input
          hidden
          type="radio"
          v-bind:id="$options.filterByInProcessStatus"
          v-bind:value="$options.filterByInProcessStatus"
          v-model="filterByStatus"
        />
      </div>
      <div class="invoice-list__table" :class="{ 'empty-table': isEmpty }">
        <form class="invoice-list__table__head" :class="{ 'is-filial': hasBranchSystem }">
          <!-- <div class="invoice-list__table__cell"> -->
          <input-sort
            v-model="sortByDate"
            v-on:input="onSortByDate"
            desc-first
            name="date"
          >
            <div
              class="invoice-list__table__cell sort date"
              v-bind:class="{ selected: sortByDate ? 'selected' : '' }">
              Дата выставления
            </div>
          </input-sort>
          <!-- </div> -->
          <div class="invoice-list__table__cell">Дата визита</div>
          <div v-if="hasBranchSystem" class="invoice-list__table__cell">Филиал</div>
          <div class="invoice-list__table__cell">Номер счета</div>
          <div class="invoice-list__table__cell">Автор</div>
          <div class="invoice-list__table__cell">Доктор</div>
          <div class="invoice-list__table__cell">Сумма</div>
          <div class="invoice-list__table__cell">Возврат</div>
          <div class="invoice-list__table__cell">Статус</div>
          <div class="invoice-list__table__cell">Комментарий</div>
        </form>
        <button
          class="invoice-list__table__row"
          v-bind:class="{ 'is-filial': hasBranchSystem }"
          type="button"
          v-bind:key="invoice.id"
          v-on:click="onRedirect(invoice.id)"
          v-for="invoice in invoiceList"
        >
          <span data-label="Дата выставления" class="invoice-list__table__cell date">
            {{ invoice.date }}
          </span>
          <span data-label="Дата визита" class="invoice-list__table__cell">
            {{ invoice.visitDate }}
          </span>
          <span v-if="hasBranchSystem" data-label="Филиал" class="invoice-list__table__cell">
            {{ invoice.branchName }}
          </span>
          <span data-label="Номер счета" class="invoice-list__table__cell">
            {{ invoice.number }}
          </span>
          <span data-label="Автор" class="invoice-list__table__cell">
            {{ invoice.authorName }}
          </span>
          <span data-label="Доктор" class="invoice-list__table__cell">
            {{ invoice.employeeName }}
          </span>
          <span data-label="Сумма" class="invoice-list__table__cell">
            {{ invoice.amount }}
          </span>
          <span data-label="Возврат" class="invoice-list__table__cell">
            {{ invoice.refund }}
          </span>
          <span
            data-label="Статус"
            class="invoice-list__table__cell"
            v-bind:class="invoice.statusId.toLowerCase()"
          >
            <span
              class="invoice-list__icon"
              v-bind:class="invoice.statusId.toLowerCase()"
            >
              {{ invoice.status }}
            </span>
          </span>
          <span data-label="Комментарий" class="invoice-list__table__cell__comment">
            <button
              type="button"
              v-if="invoice.comment !== ''"
              v-on:click.stop="onViewInvoiceComment(invoice.comment)"
            >
              <img src="@/assets/img/eye-open.svg" alt="Комментарий" />
            </button>
          </span>
        </button>
        <span v-if="isEmpty">Счетов не найдено</span>
      </div>
    </div>
    <side-slide-transition>
      <side-dialog
        v-on:cancel="onCloseAdvanceRechargeForm"
        v-if="isShownAdvanceRechargeForm"
        label="Пополнение"
      >
        <form-advance-recharge
          v-bind:cashbox-list="cashboxList"
          v-bind:is-await-request="isAwaitAdvanceRechargeRequest"
          v-bind:patient-id="patientId"
          v-on:cancel="onCloseAdvanceRechargeForm"
          v-on:submit="onAdvanceRechargeSubmit"
        />
      </side-dialog>
    </side-slide-transition>
    <open-shift-modal-dialog
      v-bind:is-await-request="isAwaitShiftRequest"
      v-model="isShowShiftOpenDialog"
      v-on:submit="onOpenShift"
    />
    <modal-dialog
      title="Изменить способ пополнения аванса"
      v-bind:value="isShownChangePaymentModeForAdvanceRechargeOperationDialog"
      v-on:input="onCancelChangePaymentModeForAdvanceRechargeOperation"
      with-cross
    >
      <form-payment-mode-change
        v-if="isShownChangePaymentModeForAdvanceRechargeOperationDialog"
        v-bind:initial-mode="rechargeOperationForChangeMode.mode"
        v-bind:mode-options="availablePaymentModesForRechargeOperationChanging"
        v-bind:total-paid="rechargeOperationForChangeMode.totalPaid"
        v-on:cancel="onCancelChangePaymentModeForAdvanceRechargeOperation(false)"
        v-on:submit="onSubmitChangePaymentModeForAdvanceRechargeOperation"
      />
    </modal-dialog>
    <modal-dialog
      title="Детализация аванса"
      v-bind:value="hasAdvanceDetails"
      v-on:input="onAdvanceDetailsCancel"
      with-cross
    >
      <table-advance-details
        v-if="hasAdvanceDetails"
        v-bind="advanceDetails"
        v-on:change-payment-mode="onChangePaymentModeFromAdvanceRechargeOperation" />
    </modal-dialog>
    <modal-dialog
      title="Комментарий счёта"
      v-bind:value="isShowInvoiceCommentModal"
      v-on:input="onCloseInvoiceCommentModal"
      v-on:on-click-outside="onCloseInvoiceCommentModal"
      with-cross
    >
      <invoice-comment
        v-bind:comment="selectedInvoiceComment"
      />
    </modal-dialog>
    <side-slide-transition>
      <side-dialog
        class="form-advance-withdrawal-dialog"
        v-on:cancel="onCloseAdvanceWithdrawalForm"
        v-if="hasAdvanceForWithdrawal"
        label="Списание аванса"
      >
        <form-advance-withdrawal
          class="form-advance-withdrawal-dialog__body"
          v-bind:is-await-request="isAwaitAdvanceWithdrawalRequest"
          v-bind:cashbox-list="cashboxListForWithdrawal"
          v-on:submit="onAdvanceWithdrawalSubmit"
        />
      </side-dialog>
    </side-slide-transition>
    <iframe
      class="invoice-list__print"
      ref="printView"
      title="printView"
    />
  </patient-profile>
</template>

<script>
import advanceRechargeMixin from '@/mixins/advanceRechargeMixin';
import notifierMixin from '@/mixins/notifierMixin';
import shiftMixin from '@/mixins/shiftMixin';
import { List, Maybe } from 'monet';
import ModalDialog from '@/components/ModalDialog.vue';
import PatientProfile from '@/views/ClinicPanel/PatientProfile.vue';
import SideSlideTransition from '@/components/SideSlideTransition.vue';
import SideDialog from '@/components/SideDialog.vue';
import FormAdvanceRecharge from '@/components/FormAdvanceRecharge.vue';
import FormAdvanceWithdrawal from '@/components/FormAdvanceWithdrawal.vue';
import FormPaymentModeChange from '@/components/FormPaymentModeChange.vue';
import onlineCheckMixin from '@/mixins/onlineCheckMixin';
import OpenShiftModalDialog from '@/components/OpenShiftModalDialog.vue';
import PatientPaidStats from '@/components/PatientPaidStats.vue';
import TableAdvanceDetails from '@/components/TableAdvanceDetails.vue';
import advanceWithdrawMixin from '@/mixins/advanceWithdrawMixin';
import InvoiceComment from '@/components/InvoiceComment.vue';
import InputSort from '@/components/InputSort.vue';

/**
 * @description Действие проверки состояния смены.
 * @type {string}
 */
const ACTION_CHECK_SHIFT_STATE = 'check-shift-state';

/**
 * @description Действие принудительно провести оплату.
 * @type {string}
 */
const ACTION_FORCE_MAKE_PAYMENT = 'force-make-payment';

/**
 * @description Примесь пополнения аванса.
 * @type {object}
 */
const rechargeMixin = {
  computed: {
    /**
     * @description Разрешить принудительно провести оплату.
     * @type {boolean}
     */
    canForceRecharge() {
      if (!this.rechargeCommandId) {
        return false;
      }
      return this.actions.includes(ACTION_FORCE_MAKE_PAYMENT)
        || this.onlineCheckActions.includes(ACTION_FORCE_MAKE_PAYMENT);
    },
  },
  data() {
    return {
      /**
       * @description Ожидание выполнения принудительного проведения оплаты.
       * @type {boolean}
       */
      isAwaitForceRecharge: false,
    };
  },
  methods: {
    /**
     * @description Обработать открытие формы пополнения аванса.
     * @returns {void}
     */
    onOpenAdvanceRechargeForm() {
      if (this.needOpenedShift) {
        this
          .checkShiftIsOpened()
          .then(async (isOpened) => {
            if (isOpened) {
              this.continueOperation();
            }
          });
      } else {
        this.continueOperation();
      }
    },
    /**
     * @description Обработать отправку запроса на пополнение аванса.
     * @param {AdvanceRechargeRequest} request Запрос.
     * @returns {void}
     */
    onAdvanceRechargeSubmit(request) {
      this
        .sendAdvanceRechargeRequest(request)
        .then((isSuccess) => {
          if (isSuccess) {
            this.reloadList();
          }
        });
    },
    /**
     * @description Продолжить операцию.
     * @returns {void}
     */
    continueOperation() {
      this.openAdvanceRechargeForm();
    },
    onForceAdvanceRecharge() {
      if (!this.rechargeCommandId) {
        return;
      }
      this.isAwaitForceRecharge = true;
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
        this.isAwaitForceRecharge = false;
      };
      this
        .$invoiceGateway
        .forcePayment(this.rechargeCommandId)
        .then((result) => result.forEachLeft(onFail))
        .catch(() => {
          this.isAwaitForceRecharge = false;
        });
    },
  },
  mixins: [advanceRechargeMixin, shiftMixin],
};

/**
 * @description Примесь списания аванса.
 * @type {object}
 */
const withdrawalMixin = {
  methods: {
    /**
     * @description Обработать открытие формы пополнения аванса.
     * @returns {void}
     */
    onOpenAdvanceWithdrawalForm() {
      if (this.needOpenedShift) {
        this
          .checkShiftIsOpened()
          .then(async (isOpened) => {
            if (isOpened) {
              this.openAdvanceWithdrawalForm();
            }
          });
      } else {
        this.openAdvanceWithdrawalForm();
      }
    },
    /**
     * @description Обработать отправку запроса на списание аванса.
     * @param {AdvanceWithdrawal} withdrawal Списание.
     * @returns {void}
     */
    onAdvanceWithdrawalSubmit(withdrawal) {
      this
        .sendAdvanceWithdrawalRequest(this.patientId, withdrawal)
        .then((isSuccess) => {
          if (isSuccess) {
            this.reloadList();
          }
        });
    },
  },
  mixins: [advanceWithdrawMixin],
};

export default {
  filterByAllStatus: 'all',
  filterByPartiallyPayedStatus: 'partially_payed',
  filterByPayedStatus: 'payed',
  filterByWaitStatus: 'wait',
  components: {
    InvoiceComment,
    InputSort,
    FormAdvanceRecharge,
    FormAdvanceWithdrawal,
    FormPaymentModeChange,
    ModalDialog,
    OpenShiftModalDialog,
    PatientPaidStats,
    PatientProfile,
    SideDialog,
    SideSlideTransition,
    TableAdvanceDetails,
  },
  computed: {
    /**
     * @description Имеется подключенная филиальная система.
     * @returns {boolean}
     */
    hasBranchSystem() {
      return this.$store.getters.isSectionAvailable('branch-system');
    },
    /**
     * @description Нужна открытая смена.
     * @returns {boolean}
     */
    needOpenedShift() {
      return this.actions.includes(ACTION_CHECK_SHIFT_STATE);
    },
    /**
     * @description Имеется детализация аванса.
     */
    hasAdvanceDetails() {
      return this.advanceDetails !== null;
    },
    /**
     * @description Имеет аванс для списания.
     */
    hasAdvanceForWithdrawal() {
      return this.advanceForWithdrawal !== null;
    },
    /**
     * @description Список счетов пуст.
     * @type {boolean}
     */
    isEmpty() {
      return !this.isAwaitRequest && this.invoiceList.size() === 0;
    },
    /**
     * @description Идентификатор пациента.
     * @type {number}
     */
    patientId() {
      return +this.$route.params.id;
    },
    isShowPatientPayments() {
      return this.patient.isSome();
    },
    patientPayments() {
      return this.patient.fold({})((patient) => patient);
    },
  },
  created() {
    this.reloadList();
    this.fetchCashboxesList();
  },
  data() {
    return {
      /**
       * @description Показывать ли комментария счёта
       * @type boolean
       */
      isShowInvoiceCommentModal: false,
      /**
       * @description Комментарий выбранного счёта.
       * @type string
       */
      selectedInvoiceComment: '',
      /**
       * @description Действия.
       * @type {string[]}
       */
      actions: [],
      /**
       * @description Детализация аванса.
       * @type {({columns: string[], rows: string[][]}|null)}
       */
      advanceDetails: null,
      /**
       * @description Фильтровать по статусу.
       * @type {string}
       */
      filterByStatus: this.$options.filterByAllStatus,
      /**
       * @description Ожидание выполнения запроса.
       * @type {bool}
       */
      isAwaitRequest: false,
      /**
       * @description Список счетов пациента.
       * @type {List}
       */
      invoiceList: List(),
      /**
       * @description Пациент.
       * @type {Maybe}
       */
      patient: Maybe.none(),
      /**
       * @description Список касс.
       */
      cashboxList: [],
      sortByDate: 'desc',
    };
  },
  methods: {
    onSortByDate(sort) {
      this.sortByDate = sort;
      this.reloadList();
    },
    /**
     * @description Обработка закрытия модального окна комментария.
     * @returns {void}
     */
    onCloseInvoiceCommentModal() {
      this.isShowInvoiceCommentModal = false;
      this.selectedInvoiceComment = '';
    },
    /**
     * @description Обработать переход.
     * @param invoiceId Id счёта
     * @returns {void}
     */
    onRedirect(invoiceId) {
      const route = this.getNavigation(invoiceId);
      this.$router.push(route);
    },
    /**
     * @description обработать показ комментария счёта.
     * @param {numeric} invoiceComment Комментарий счёта
     * @returns {void}
     */
    onViewInvoiceComment(invoiceComment) {
      this.selectedInvoiceComment = invoiceComment;
      this.isShowInvoiceCommentModal = true;
    },
    /**
     * @description Получить путь до счета.
     * @param {number} invoiceId Идентификатор счета.
     * @returns {any}
     */
    getNavigation(invoiceId) {
      const params = {
        id: this.patientId,
        invoiceId,
      };
      return {
        name: 'ClinicPanelPatientInvoice',
        params,
      };
    },
    /**
     * @description Получить список касс.
     * @returns {void}
     */
    fetchCashboxesList() {
      const onSuccess = (cashboxes) => {
        this.cashboxList = cashboxes;
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      this
        .$cashboxGateway
        .viewList()
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Получить список.
     * @returns {void}
     */
    reloadList() {
      const onSuccess = ({ actions, invoiceList, patient }) => {
        this.actions = actions;
        this.invoiceList = invoiceList;
        this.patient = Maybe.some(patient);
        const { commandId } = patient;
        this.rechargeCommandId = commandId;
        if (commandId !== null) {
          this
            .waitAdvanceRechargeCheckPrinted(commandId)
            .then((isSuccess) => {
              if (isSuccess) {
                setTimeout(this.reloadList, 2000);
              } else {
                this.isAwaitForceRecharge = false;
              }
            });
        }
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      this.isAwaitRequest = true;
      const filter = this.filterByStatus
        && this.filterByStatus !== this.$options.filterByAllStatus
        ? this.filterByStatus
        : null;
      this.$invoiceGateway
        .viewList(this.patientId, filter, this.sortByDate || null)
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => {
          this.isAwaitRequest = false;
          this.isAwaitForceRecharge = false;
        });
    },
    /**
     * @description Обработать отмену показа для детализации аванса.
     * @returns {void}
     */
    onAdvanceDetailsCancel() {
      this.advanceDetails = null;
    },
    /**
     * @description Обработать отмену показа аванса для списания.
     * @returns {void}
     */
    onAdvanceForWithdrawalCancel() {
      this.advanceForWithdrawal = null;
    },
    /**
     * @description Обработать открытие детализации аванса.
     * @returns {void}
     */
    onAdvanceDetailsOpen() {
      this
        .$invoiceGateway
        .viewPatientAdvanceDetails(this.patientId)
        .then((result) => {
          result.forEachLeft(({ title }) => { this.notifyFail(title); });
          result.forEach((details) => {
            this.advanceDetails = details;
          });
        });
    },
    /**
     * @description Обработать печать акта.
     * @param {string} dateFrom
     * @param {string} dateTo
     * @returns {void}
     */
    onPrintAct(dateFrom, dateTo) {
      const onSuccess = (response) => {
        const blob = new Blob([response], { type: 'text/html' });
        const container = this.$refs.printView;
        container.setAttribute('src', URL.createObjectURL(blob));
        container.onload = () => {
          container.contentWindow.print();
        };
      };
      this
        .$patientGateway
        .formMutualSettlementsAct(this.patientId, dateFrom, dateTo)
        .then((result) => result.fold(this.notifyFail, onSuccess));
    },
  },
  mixins: [notifierMixin, rechargeMixin, onlineCheckMixin, withdrawalMixin],
  name: 'ClinicPanelPatientInvoiceList',
  watch: {
    filterByStatus: 'reloadList',
  },
};
</script>

<style lang="scss">
@use "@/scss/buttons";
$switch-width: 16px;

.form-advance-withdrawal-dialog {
  & &__body {
    margin-top: 1.5rem;
  }
}

.invoice-list {
  &__button {
    &-add {
      @include buttons.btn-blue(100%, 40px, 16px);
      @include buttons.btn-blue-add(16px);
      max-width: 299px;
    }
  }
  &__filters {
    margin-top: 39px;
    display: flex;
    flex-flow: row wrap;
    gap: 6px;
    &__item {
      display: flex;
      align-items: center;
      color: var(--reading-color);
      font-size: 14px;
      line-height: 17px;
      padding: 8px 15px;
      border: 1px solid #c2cfe0;
      border-radius: 4px;
      cursor: pointer;
      &:hover {
        border-color: var(--action-color);
        border-width: 2px;
        padding: 7px 14px;
      }
    }
    input:checked + &__item {
      border-color: var(--action-color);
      border-width: 2px;
      padding: 7px 14px;
    }
  }
  &__empty {
    cursor: pointer;
    font-size: 18px;
    font-weight: 400;
    line-height: 22px;
    margin: 20px 0 0 0;
    border-bottom: 1px solid transparent;
    b {
      color: var(--action-color);
    }
    &:hover {
      border-bottom: 1px solid var(--action-color);
    }
  }
  &__table {
    counter-reset: counterInvoices;
    margin: 25px 0 0 0;
    overflow-x: auto;
    &:not(.empty-table) {
      .invoice-list__table__head,
      .invoice-list__table__row {
        width: max(100%, 1200px);
        &.is-filial {
          width: max(100%, 1300px);
        }
      }
    }
    &__head,
    &__row {
      display: grid;
      grid-template-columns: 180px 1fr 1fr 300px 1fr 100px 100px 110px minmax(110px, 140px);
      align-items: center;
      font-size: 14px;
      line-height: 17px;
      &.is-filial {
        grid-template-columns:
          180px 1fr minmax(150px, 1fr) 1fr
          minmax(180px, 1fr) 1fr 100px
          100px 110px minmax(110px, 140px);
      }
    }
    &__head {
      font-weight: 700;
      border-bottom: 2px solid #0489e0;
    }
    &__row {
      text-decoration: none;
      color: var(--reading-color) !important;
      text-align: left;
      border-bottom: 1px solid #eaeff3;
      &:hover {
        background: #eaeff3;
        .invoice-list__table__cell {
          background: #eaeff3;
        }
      }
    }
    &__cell {
      align-items: center;
      display: flex;
      margin: 0 auto;
      padding: 12px 8px;
      transition: color var(--animate-duration);
      &__comment {
        margin: 0 auto;
      }
      &.payed,
      &.partially_payed {
        margin-inline: 0 auto;
        width: 100%;
        height: 100%;
        background-color: #e4ffec;
      }
      &.sort {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        &:after {
          content: '';
          background-image: url("@/assets/img/checked/checked-grey.svg");
          background-repeat: no-repeat;
          background-size: contain;
          background-position: center;
          width: 10px;
          height: 10px;
          margin: 0 0 0 5px;
        }
        &:hover {
          text-decoration: none;
        }
        &.selected {
          color: var(--action-color);
        }
      }
      &.date {
        @media screen and (min-width: 681px) {
          justify-content: start;
          margin-inline: 5px auto;
        }
      }
    }
  }
  &__icon {
    display: flex;
    align-items: center;
    &.payed:before {
      flex-shrink: 0;
      background-image: url("@/assets/img/checked/all-checked-green.svg");
      background-repeat: no-repeat;
      background-size: contain;
      content: "";
      height: 18px;
      margin-right: 5px;
      width: 20px;
    }
    &.partially_payed:before {
      flex-shrink: 0;
      background-image: url("@/assets/img/checked/checked-green.svg");
      background-repeat: no-repeat;
      background-size: contain;
      content: "";
      height: 15px;
      margin-right: 10px;
      width: 15px;
    }
    &.wait:before {
      background-color: #abb1a3;
      border-radius: 50%;
      content: "";
      height: 6px;
      margin-left: 4px;
      margin-right: 15px;
      width: 6px;
      flex-shrink: 0;
    }
  }
  &__print {
    display: none;
  }
}

@media screen and (max-width: 1200px) {
  .invoice-list__table__row,
  .invoice-list__table__head {
    grid-template-columns: 140px 100px 80px 1fr 1fr min(130px) 1fr 110px minmax(110px, 140px);
  }
}

@media screen and (max-width: 730px) {
  .invoice-list__filters__item.invoice-list__icon:before {
    display: none;
  }
}

@media screen and (max-width: 680px) {
  .invoice-list__filters {
    flex-direction: column;
    &__item.invoice-list__icon:before {
      display: flex;
    }
  }
  .invoice-list__table {
    &__head {
      display: none;
    }
    &:not(.empty-table) {
      .invoice-list__table__row {
        width: 100% !important;
      }
    }
    &__row,
    &__row.is-filial {
      grid-template-columns: 1fr;
      grid-gap: 5px;
      margin: 0 0 20px 0;
    }
    &__cell {
      display: flex;
      justify-content: space-between;
      margin: 0;
      padding: 9px 8px;
      &.payed,
      &.partially_payed {
        margin: 0;
        width: auto;
      }
      &__comment {
        display: flex;
        justify-content: space-between;
        margin-inline: 0;
        padding: 9px 8px;
        &:empty {
          display: none;
        }
      }
      &::before,
      &__comment:not(:empty):before {
        content: attr(data-label) !important;
        font-weight: 700;
        margin-right: 20px;
      }
    }
  }
}
</style>
